import {Component, Input, OnInit} from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';

@Component({
  selector: 'pop-in-text',
  templateUrl: './pop-in-text.component.html',
  styleUrls: ['./pop-in-text.component.css'],
  animations: [
    trigger('heroState', [
      state('inactive', style({
        transform: 'scale(0)'
      })),
      state('active',   style({
        transform: 'scale(1)'
      })),
      transition('inactive => active', animate('300ms ease-in',keyframes([
        style({transform:'scale(0)',offset:0}),
        style({transform:'scale(1.3)',offset:0.5}),
        style({transform:'scale(1)',offset:1}),
      ]))),
      // transition('active => inactive', animate('100ms ease-out'))
    ])
  ]
})

export class PopInTextComponent implements OnInit{

  @Input() public text;
  @Input() private delay;
  public state = 'inactive';

  constructor() {}
  
  ngOnInit(){
    setTimeout(()=>{
      this.toggleState();
    },this.delay)
  }
  toggleState() {
    this.state = 'active';
  }
}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/pop-in-text/pop-in-text.component.ts